import React from "react";
import { Card, CardHeader, CardBody, CardTitle } from "reactstrap";
import DownloadTemplates from "./DownloadTemplates";

import "./Vendor.css";

const Vendor = (props) => {
  const { user } = props;

  // const Json = ({ data }) => <pre>{JSON.stringify(data, null, 4)}</pre>;

  return (
    <div className="Vendor">
      <Card>
        <CardHeader tag="h5" className="bg-light text-dark font-weight-bold">
          Vendor
        </CardHeader>
        <CardBody>
          <CardTitle>{user.name}, you are logged on as vendor.</CardTitle>
          {/* <Json data={user} /> */}
        </CardBody>
      </Card>
      {user.prefs.fileTypes && user.prefs.fileTypes.length ? (
        <DownloadTemplates
          params={{ role: user.role, fileTypes: user.prefs.fileTypes }}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default Vendor;
